<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="dateboard">
      <div class="wrap">
        <div class="item">
          <div class="label">累计待结款金额：</div>
          <div class="value">{{ num1 || 0 }}</div>
        </div>
      </div>
    </div>

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <!-- <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" /> -->
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showTotal="true"
      :showIndex="true" :getTotal="getTotal" :btns="btns" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />

    <FormDialog ref="dialog" :title="title" :width="'570px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onChange="onModalChange" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'repay',
      getListUrl: 'repayrec',
      breadcrumb: [
        { name: "财务管理" },
        // { name: "应收账款管理", path: `/finance/shipper` },
        // { name: "客户结款记录" },
      ],
      formInline: {
      },
      formCtrl: [
        {
          ...this.ctrls.month,
          label: "结款日期",
          keyName: "repaytime",
        },
      ],
      cols: [
        { keyName: "paymoney", label: "结款金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "repaytime", label: "结款时间", minwidth: 120 },
        { keyName: "remark", label: "备注", minwidth: 120 },
      ],
      getTotalProperty: ["paymoney"],
      btns: [
        {
          ...this.viewBtn,
          title: "结款记录",
          cb: ({ id, custom, paymoney, repaytime, photo, remark, cid }) => {
            // console.log(id)
            this.title = '查看结款记录'
            this.viewMode = true
            this.mform = { id, customname: custom, paymoney, repaytime, photo, remark, cid }
            // console.log({ ...this.mform })
            this.showDialog()
          },
        },
      ],
      title: '结款记录',
      mform: {
        paymoney: undefined,
        repaytime: undefined,
        photo: undefined,
      },
      mrules: {
        paymoney: [
          {
            required: true,
            message: '请填写结款金额',
            trigger: 'blur',
          }
        ],
        repaytime: [
          {
            required: true,
            message: '请选择结款日期',
            trigger: 'blur',
          }
        ],
        photo: [
          {
            required: true,
            message: '请上传结款凭证',
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          label: "公司名称",
          keyName: "customname",
          type: "text",
          disabled: true,
        },
        {
          label: "结款金额",
          keyName: "paymoney",
          err: "请填写结款金额",
          type: "number",
        },
        {
          label: "结款日期",
          keyName: "repaytime",
          err: "请选择结款日期",
          type: "date",
        },
        {
          label: "结款凭证",
          keyName: "photo",
          tips: "最多上传10张图片",
          type: "file",
          ptype: "receipt",
          max: 10,
        },
        {
          label: "备注",
          keyName: "remark",
          err: "请填写备注信息",
          type: "textarea",
          rows: 3,
        },
      ],
      viewMode: false,
      num1: 0,
    };
  },
  methods: {
    getData() {
      let url = `custom/summary`;
      const params = {
        userid: this.user.id,
      }

      this.post(url, params, ({ msg, cmoney }) => {
        if (msg === 'success' && cmoney) {
          this.num1 = cmoney
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
  },
  created() { },
  mounted() {
    this.getData()
  },
};
</script>
<style lang="less" scoped>
/deep/ .dialog {
  .el-form {
    padding-right: 50px;

    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 100%;
    }
  }

  // .btns {
  //   margin-left: 110px;
  // }
}

/deep/ .el-dialog .btns .mians {
  text-align: center;
}

.dateboard {
  box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.04);
  border-radius: 3px;
  background: #fff;
  // border-radius: 5px 5px 0 0;
  overflow: hidden;

  .wrap {
    display: flex;
    align-items: center;
    padding: 20px;
    margin: 20px;
    background: #F7F7F7;
  }

  .item {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #606266;

    &:not(:first-of-type) {
      margin-left: 100px;
    }

    .label {
      position: relative;
      padding-left: 36px;
      height: 25px;
      line-height: 25px;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        background: #FFFFFF url(../../../assets/img/ico_payment_01.png) no-repeat center center;
        background-size: 11px;
      }

    }

    &.item01 {
      .label {

        &::before {
          background-image: url(../../../assets/img/ico_payment_02.png);
        }
      }
    }

    .value {
      height: 25px;
      line-height: 25px;
    }
  }
}
</style>
